import { render, staticRenderFns } from "./ModelIndex.vue?vue&type=template&id=f6d2b3e2&scoped=true&"
import script from "./ModelIndex.vue?vue&type=script&lang=js&"
export * from "./ModelIndex.vue?vue&type=script&lang=js&"
import style0 from "./ModelIndex.vue?vue&type=style&index=0&id=f6d2b3e2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6d2b3e2",
  null
  
)

component.options.__file = "ModelIndex.vue"
export default component.exports